module.exports = __webpack_public_path__ + "static/media/DSCF4199.95e110ed.jpg";